import { DOCUMENT } from '@angular/common';
import {
  Component,
  ElementRef,
  EventEmitter,
  Inject,
  Input,
  OnDestroy,
  OnInit,
  Output,
  Renderer2,
  ViewEncapsulation
} from '@angular/core';
import { MenuItem } from '@app/shared/models/menu.interface';
import { fromEvent, Subject } from 'rxjs';
import { debounceTime, takeUntil } from 'rxjs/operators';

@Component({
  selector: 'vfs-main-menu',
  templateUrl: './main-menu.component.html',
  styleUrls: ['./main-menu.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class MainMenuComponent implements OnInit, OnDestroy {
  @Input() items: MenuItem[];
  @Input() expanded: boolean;
  @Output() toggleMenu = new EventEmitter();

  private destroyed = new Subject();

  headerHeight = 53;
  footerHeight = 42;
  elementHeight = 56;

  constructor(private element: ElementRef, private renderer: Renderer2, @Inject(DOCUMENT) private document: Document) {}

  ngOnInit() {
    fromEvent(window, 'resize')
      .pipe(takeUntil(this.destroyed), debounceTime(100))
      .subscribe(() => {
        this.setMoreItems();
      });
    this.setMoreItems();
  }

  ngOnDestroy() {
    this.destroyed.next();
  }

  /**
   * Calculate position of submenus if menu is expanded or not.
   */
  submenuPosition() {
    const sidenav = document.getElementsByClassName('vfs-menu-body');
    const submenus = document.getElementsByClassName('mat-menu-panel');
    const cdk = document.getElementsByClassName('cdk-overlay-connected-position-bounding-box');
    const cdkSubmenu: HTMLElement = cdk.item(0) as HTMLElement;
    const sidenavWidth: HTMLElement = sidenav.item(0) as HTMLElement;

    if (this.expanded) {
      cdkSubmenu.style.marginLeft = sidenavWidth.offsetWidth + 4 + 'px';
    }

    if (submenus.length === 1 && cdk.length === 2) {
      const cdkSubmenu1: HTMLElement = cdk.item(1) as HTMLElement;
      cdkSubmenu1.style.marginLeft = sidenavWidth.offsetWidth + 4 + 'px';
    }

    for (let i = 1; i < submenus.length; i++) {
      const cdkSubPanel: HTMLElement = cdk.item(1) as HTMLElement;
      const lastPanel: HTMLElement = submenus.item(i - 1) as HTMLElement;
      cdkSubPanel.style.marginLeft = lastPanel.offsetWidth + 'px';
    }
  }

  /**
   * Capture the click event outside the menu and collapse it.
   */
  closeMenu() {
    const fullScreenPanel = document.getElementsByClassName('fullscreen')[0];
    fullScreenPanel.addEventListener('click', event => {
      if (this.expanded) {
        this.collapseMenu();
      }
    });
  }

  collapseMenu() {
    if (this.expanded) {
      this.toggleMenu.emit();
    }
  }

  /**
   * Calcule elements to show and set the elements to include in more buttons.
   */
  setMoreItems() {
    const height = window.innerHeight - this.headerHeight - this.footerHeight;
    let elementsToShow = Math.floor(height / this.elementHeight);

    if (elementsToShow < this.items.length) {
      elementsToShow -= 1;
    }

    for (let i = 0; i < this.items.length; i++) {
      i < elementsToShow ? (this.items[i].visible = true) : (this.items[i].visible = false);
    }
  }

  /**
   * @returns Array with the elements to show in main menu.
   */
  getVisibleItems(): MenuItem[] {
    const visibleItems: MenuItem[] = [];
    this.items.forEach(element => {
      if (element.visible) {
        visibleItems.push(element);
      }
    });

    return visibleItems;
  }

  /**
   * @returns Array with the elements to include in more button
   */
  getMoreItems(): MenuItem[] {
    const moreItems: MenuItem[] = new Array();
    this.items.forEach(element => {
      if (!element.visible) {
        moreItems.push(element);
      }
    });
    return moreItems;
  }
}
